<template>
  <div>
    <va-card>
      <vue-element-loading :active="visible" :is-full-screen="true" />

      <div class="row">
        <div class="flex md10 sm6 xs12">
          <h4 style="font-size: 24px !important" class="card-title mx-2">
            USER TYPES
          </h4>
        </div>
        <div class="flex md2 sm6 xs6 d-flex justify--end">
          <b-button variant="secondary" v-b-modal.modal-footer-sm>
            ADD NEW
            <va-icon
              style="font-size: 22px !important"
              name="fa fa-plus-circle"
            />
          </b-button>
        </div>
      </div>
      <div class="flex md12 xs12 sm6">
        <div style="padding-right: 20px !important" class="d-flex justify--end">
          <b-modal id="modal-footer-sm" title button-size="sm" hide-footer>
            <form @submit="onSubmit">
              <div class="form-group">
                <label for="exampleInputEmail1">ADD NEW USER TYPE</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  v-model="uname"
                  required
                  aria-describedby="emailHelp"
                  placeholder="Add New User Type"
                />
              </div>
              <div class="flex xs12">
                <va-card>
                  <output>
                    <img
                      :src="previewUrl"
                      v-if="previewUrl"
                      style="width: 150px; height: 150px"
                    />
                    <p v-else>No image...</p>
                  </output>
                  <input
                    type="file"
                    required
                    id="file"
                    accept="image/*"
                    v-on:change="uploadImage($event)"
                  />
                </va-card>
              </div>
              <button class="btn btn-success" type="submit">ADD</button>
            </form>
          </b-modal>
        </div>
      </div>
      <div class="container" style="padding-top: 20px">
        <div class="flex md12 sm6 xs12 overflow-auto">
          <div class="overflow-aut0" style="overflow: auto">
            <b-table
              style="oadding: 40px"
              hover
              v-if="data.length"
              id="my-table"
              :fields="fields"
              :items="data"
              :per-page="perPage"
              :current-page="currentPage"
              small
              borderless
              head-variant="dark"
              table-variant="light"
            >
              <template v-slot:cell(icon)="data1" style="text-align: center">
                <img
                  v-if="data1.item.icon != null"
                  v-bind:src="baseURL + data1.item.icon"
                  width="40px"
                  height="40px"
                />
                <p v-else>No Image</p>
              </template>
              <template v-slot:cell(_id)="data">
                <span style="padding-left: 20px !important">
                  <router-link :to="'/editusertype/' + data.item._id">
                    <b-button type="submit" variant="info">Update</b-button>
                  </router-link>
                </span>
                <span style="padding-left: 20px !important">
                  <b-button variant="danger" @click="deleteCType(data.item._id)"
                    >Delete</b-button
                  >
                </span>
              </template>
            </b-table>
            <p v-else>No Data Found</p>
            <br />
            <b-pagination
              align="center"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
            <br />
          </div>
        </div>
      </div>
    </va-card>
  </div>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      type: "",
      previewUrl: "",
      visible: false,
      perPage: "15",
      currentPage: 1,
      uname: null,
      msg: "",
      icon: "",
      id: "",
      dat: [],
      data: [],
      fields: [
        {
          label: "User Types",
          key: "uname",
          sortable: false,
          thClass: " cnt",
          tdClass: "cnt",
        },
        {
          label: "User Icon",
          key: "icon",
          sortable: false,
          // tdClass: 'tblpd',
        },
        {
          label: "Create Date",
          key: "create_date",
          sortable: false,
          tdClass: "cnt",
          thClass: "cnt",
        },
        {
          label: " Action",
          key: "_id",
          sortable: false,
          thClass: "cnt",
          tdClass: "cnt",
        },
      ],
    };
  },
  mounted: function () {
    this.getList();
  },
  computed: {
    rows() {
      return this.data.length;
    },
  },
  methods: {
    deleteCType(val) {
      this.visible = true;
      if (confirm("Are you sure?")) {
        this.visible = true;
        axios({
          method: "POST",

          headers: {
            token: localStorage.getItem("token"),
          },
          url: "/usertype/delete/" + val,
        })
          .then((response) => {
            this.visible = false;
            if (response.data.status) {
              this.getList();
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "success" });
            } else {
              this.msg = response.data.msg;
              this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
            }
          })
          .catch((err) => {
            this.visible = false;
            this.errors.push(err);
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: "error" }
            );
          });
      } else {
        this.visible = false;
        this.$router.push({ name: "usertype" });
      }
    },
    uploadImage() {
      this.selectedFile = event.target.files[0];
      this.url = URL.createObjectURL(this.selectedFile);
      const file = event.target.files[0];
      if (file) {
        this.stat = 1;
      } else {
        this.stat = 0;
        return false;
      }
      if (!file.type.match("image.*")) {
        // return false
        this.stat = 0;
      } else {
        this.stat = 1;
      }
      const reader = new FileReader();
      const that = this;
      reader.onload = function (e) {
        that.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onSubmit(evt) {
      // this.visible = true
      var data = {};
      data["uname"] = this.uname;
      evt.preventDefault();
      axios({
        method: "POST",
        url: "/usertype/add",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: data,
      })
        .then((response) => {
          this.msg = response.data.msg;
          this.id = response.data.UTid;
          if (response.data.status === true && this.stat === 1) {
            let formData = new FormData();
            formData.append("icon", this.selectedFile);
            console.log(this.selectedFile);
            formData.append("id", this.id);
            this.visible = true;
            axios({
              method: "post",
              url: "/usertype/upload/icon/" + this.id,
              data: formData,
              headers: {
                "Content-Type": "multipart/form-data",
                token: localStorage.getItem("token"),
              },
            })
              .then((response) => {
                if (response.data.status === true) {
                  this.$dlg.alert(
                    this.msg,
                    () => {
                      this.$bvModal.hide("modal-footer-sm");
                      this.getList();
                    },
                    { messageType: "success" }
                  );
                }
                if (response.data.status === false) {
                  this.visible = "false";
                  this.$dlg.alert(
                    (this.msg = "UserType Added Successfully without Icon"),
                    () => {
                      this.$bvModal.hide("modal-footer-sm");
                      this.getList();
                    },
                    { messageType: "error" }
                  );
                }
              })

              .catch((e) => {
                console.log(e);
                this.visible = false;
              });
          }
          if (response.data.status === false) {
            this.visible = "false";
            this.$dlg.alert(
              (this.msg = response.data.msg),
              () => {
                this.$bvModal.hide("modal-footer-sm");
                this.getList();
              },
              { messageType: "error" }
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getList() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/usertype/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          this.data = response.data.data;
          for (var i = 0; i < this.data.length; i++) {
            var dt = this.data[i].create_date;
            dt = new Date(dt);
            dt = dt.toString();
            dt = dt.slice(0, 15);
            this.data[i].create_date = dt;
          }
          if (response.data.status === true) {
            this.data = response.data.data;
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch((e) => {
          console.log(e);
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
  },
};
</script>
<style>
 
.tablebutto {
  width: 21% !important;
  text-align: left;
}
</style>
